import React from 'react';
import PropTypes from 'prop-types';
import { useLazyLoadContext } from '~spa/Components/LazyLoad/LazyLoad';
import './styles/carousel-icons.scss';
import { useService } from './service';
import { buildSpectateStaticAssetUrl } from '~spa/Utils/Spectate';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import SportCarouselIcon from './SportCarouselIcon';
import CasinoCarouselIcon from './CasinoCarouselIcon';

const CAROUSEL_ICONS_URL = buildSpectateUrl('/carousel_requests/getCarousel');

const CarouselIcons = ({source}) => {
    const { lazyLoadHasLoaded, lazyLoadIsEmpty } = useLazyLoadContext();
    const assetUrl = buildSpectateStaticAssetUrl('/upload/carousel_icons/');
    const carouselClassName = 'iconsCarousel';

    const carouselIcons = useService(CAROUSEL_ICONS_URL, { lazyLoadHasLoaded, lazyLoadIsEmpty });

    const getLabel = label => label.split('|');

    if (!carouselIcons || !carouselIcons.length) {
        return null;
    }

    return (
        <div className={carouselClassName}>
            <ul className={`${carouselClassName}__wrapper`}>
                {
                    carouselIcons.map((icon, index) => {
                        const IconComponent = icon.link_type === 'CASINO'
                            ? CasinoCarouselIcon
                            : SportCarouselIcon;

                        return (
                            <li key={index} className={`${carouselClassName}__item`}>
                                <IconComponent
                                    iconData={icon}
                                    className={`${carouselClassName}__link`}
                                    source={source}
                                >
                                    <img
                                        className={`${carouselClassName}__icon`}
                                        src={`${assetUrl}${icon.filename}`}
                                        loading="lazy"
                                        alt="Sport Carousel Icon" />
                                    <div className={`${carouselClassName}__label`}>
                                        {getLabel(icon.label).map((label, i) => <div key={i}>{label}</div>)}
                                    </div>
                                </IconComponent>
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );
};

CarouselIcons.propTypes = {
    source: PropTypes.string,
};

CarouselIcons.defaultProps = {
    source: '',
};

export default CarouselIcons;
